export enum FilterType {
	KEYWORD_WHAT = "kw-what",
    KEYWORD_WHERE = "kw-where",
    KEYWORD = "kw",
    ORGANISATIONS = "oi",
    DISCIPLINES = "di",
    EDUCATION_LEVEL = "lv",
    CONTINENT = "rg",
    COUNTRY = "ci",
    AREA = "ae",
    TUITION_FEE = "tr",
    DURATION = "dur",
    ATTENDANCE = "at",
    DENSITIES = "de",
    DEGREE_TYPE = "dg",
    EDUCATIONAL_FORM = "ef",
    SPECIAL_PROGRAMMES = "sps",
    CAMPAIGN_TYPE = "campaign-type"
}
